
import Support from '../../utils/global/Support.js'

const support = new Support()

const GLOBAL_DATA = {
    // height: 2000,
    width: 256,
    imgXRatio: 16/9,
    imgYRatio: 16/18,
}


const ROOT = '/assets/img/home/' + ((support.maxScreen > 1024) ? 'hd/' : 'md/')
const VIDEO = '/assets/video/'

 /*
    src = list of pictures and videos :
    [video, img hd]
    [img hd]

    type = image layout

    type 1

        ┌───────────────┐
        │               │
        │       1       │
        │               │
        └───────────────┘

    type 2

        ┌───────┬───────┐
        │   1   │   2   │
        └───────┴───────┘

    type 22

        ┌───────┬───────┐
        │       │       │
        │   1   │   2   │
        │       │       │
        └───────┴───────┘

    type 21

        ┌───────┬───────┐
        │   1   │       │
        ├───────┤   3   │
        │   2   │       │
        └───────┴───────┘

    type 12

        ┌───────┬───────┐
        │       │   2   │
        │   1   ├───────┤
        │       │   3   │
        └───────┴───────┘

*/
const BLOCK_LIST = [

    {
        type: 2,
        src: [
            [`${ROOT}bg-ban1-l.jpg`],
            [`${ROOT}bg-ban1-r.jpg`]
        ]
    },

    {
        type: 1,
        src: [
            [`${VIDEO}bg-ban2.mp4`, `${ROOT}bg-ban2.jpg`]
        ]
    },

    {
        type: 21,
        src: [
            [`${ROOT}bg-ban3-tl.jpg`],
            [`${ROOT}bg-ban3-bl.jpg`],
            [`${ROOT}bg-ban3-r.jpg`]
        ]
    },

    {
        type: 1,
        src: [
            [`${ROOT}bg-ban4.jpg`]
        ]
    },

    {
        type: 2,
        src: [
            [`${ROOT}bg-ban5-l.jpg`],
            [`${VIDEO}bg-ban5-r.mp4`, `${ROOT}bg-ban5-r.jpg`]
        ]
    },

    {
        type: 22,
        src: [
            [`${ROOT}bg-ban6-l.jpg`],
            [`${ROOT}bg-ban6-r.jpg`]
        ]
    },

    {
        type: 21,
        src: [
            [`${ROOT}bg-ban7-tl.jpg`],
            [`${VIDEO}bg-ban7-bl.mp4`, `${ROOT}bg-ban7-bl.jpg`],
            [`${ROOT}bg-ban7-r.jpg`]
        ]
    },

    {
        type: 8,
        src: [
            [`${ROOT}bg-ban8.jpg`]
        ]
    },

]

export { BLOCK_LIST, GLOBAL_DATA }
